module.exports = __webpack_public_path__ + "img/msgqj.c76f3933.jpg";